module.exports = __webpack_public_path__ + "assetst/img/schedule-type-icon.42fb9abf.svg";